import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { getBasicInfo, getSessionStorageItem, SESSION_STORAGE_ANALYSIS_KEY, setBasicInfo } from "../../../sessionStorage";
import AnalysisData from "../../Helpers/Constants/AnalysisData";
import NeedsAnalysis from "./NeedAnalysis";

export default function NeedsCalculator(props) {
  const sessionStorageFromAnalysis = getSessionStorageItem(SESSION_STORAGE_ANALYSIS_KEY);
  const initialNeedAnalysisValues = sessionStorageFromAnalysis || AnalysisData();
  const [needAnalysisFormValues, setNeedAnalysisFormValues] = useState(initialNeedAnalysisValues);

  const handleModalOnClose = () => {
    const basicInfoFromSessionStorage = getBasicInfo();
    basicInfoFromSessionStorage.gender = needAnalysisFormValues.gender === 'Female' ? 'F' : needAnalysisFormValues.gender === 'Male' ? 'M' : needAnalysisFormValues.gender ? needAnalysisFormValues.gender : '';
    basicInfoFromSessionStorage.birthdate = needAnalysisFormValues.birthdate;
    setBasicInfo(basicInfoFromSessionStorage);
    sessionStorage.setItem(SESSION_STORAGE_ANALYSIS_KEY, JSON.stringify({ ...needAnalysisFormValues }));
    props.fields.setModalNeedsCalculatorIsOpen(false);
  };

  return (
    <Modal show={props.fields.modalNeedsCalculatorIsOpen} className="need-analysis-model" scrollable={true} onHide={() => handleModalOnClose()} backdrop="true" size="lg">
      <Modal.Body>
        <NeedsAnalysis fields={props.fields} isPrequote={props.isPrequote} isCustomTerm={props.isCustomTerm} setNeedAnalysisFormValues={setNeedAnalysisFormValues} />
      </Modal.Body>
    </Modal>
  );
}


// WEBPACK FOOTER //
// ./src/components/Tools/NeedsAnalysis/NeedsCalculator.js